
export const setCurrentToSaved = (state) => state.change((s) => ({
    ...s,
    saved: state.value.current,
}));
